<template>
  <div class="SignIn" v-if="pageShow">
    <Navbar title="配送单签收" :default-bg="false" path="/"/>
    <div class="division">
      <div class="division-name">{{ singleAddress.roomName }}</div>
      <div class="date date-flex">
        <div class="date-flex-l">{{ singleAddress.date }} {{ singleAddress.mealName }}</div>
        <div class="date-flex-r">配送人：食堂</div>
      </div>
      <div class="signatory">
        <div class="signatory-title">签收人</div>
        <div class="signatory-area">病区签收码</div>
      </div>
      <div class="discharge-list">
        <table>
          <tr v-for="(item,index) in leaveHospitalUsers" :key="index">
            <td>{{ item.bedName }}</td>
            <td>{{ item.userNo }}</td>
            <td>{{ item.name }}</td>
            <td>已出院</td>
          </tr>
        </table>
      </div>
      <div class="grid-container">
        <div class="catering">
          <div class="catering-title">餐品</div>
          <table>
            <thead>
            <tr>
              <th>床号别</th>
              <th>病历号</th>
              <th>姓名</th>
              <th>餐别</th>
              <th>质地</th>
              <th>成分别</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in singleAddress.hospitalOrdersUserMsg" :key="index" @click="showRecordDetail(item.orderItemId)" :class="item.returnType!=null && item.returnType==4 ? 'tr-red':''">
              <td>{{ item.bedName }}</td>
              <td>{{ item.userNo }}</td>
              <td>{{ item.userName }}</td>
              <td>{{ item.goodsNo }}</td>
              <td>{{ item.quality }}</td>
              <td>{{ item.attr }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="meal">
          <table>
            <thead>
            <tr>
              <th>床号别</th>
              <th>病历号</th>
              <th>姓名</th>
              <th>餐品</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in singleAddress.systemOrdersUserMsg" :key="index" @click="showRecordDetail(item.orderItemId)" :class="item.returnType!=null && item.returnType==4 ? 'tr-red':''">
              <td>{{ item.bedName }}</td>
              <td>{{ item.userNo }}</td>
              <td>{{ item.userName }}</td>
              <td>{{ item.goodsName }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="catering-total">
          <div class="catering-title">餐别统计</div>
          <table>
            <thead>
            <tr>
              <th>医院订餐</th>
              <th>用户订餐</th>
              <th>总计</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ singleAddress.hospitalOrderNum }}</td>
              <td>{{ singleAddress.systemOrderNum }}</td>
              <td>{{ singleAddress.total }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="hospitalMeal">
          <table>
            <thead>
            <tr>
              <th>餐品名称（医院订餐）</th>
              <th>份数</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in singleAddress.hospitalOrders" :key="index" >
              <td>{{ item.goodsName }}</td>
              <td>{{ item.orderNum }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="userMeal">
          <table>
            <thead>
            <tr>
              <th>餐品名称（用户订餐）</th>
              <th>份数</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in singleAddress.systemOrders" :key="index">
              <td>{{ item.goodsName }}</td>
              <td>{{ item.orderNum }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="noMore">没有更多了...</div>
      <div class="confirm">
        <button v-if="status == 4" style="background: #CCCCCC;color: #FFFFFF">已签收</button>
        <button v-else-if="status == 5" style="background: #CCCCCC;color: #FFFFFF">无可签收订单</button>
        <button v-else-if="status == 0" style="background: #CCCCCC;color: #FFFFFF">未开始</button>
        <button v-else-if="status == 1" style="background: #CCCCCC;color: #FFFFFF">订餐中</button>
        <button v-else class="themeColor" @click="confirmSign">确认签收</button>
      </div>
    </div>

    <van-popup v-model="recordDetail" round>
      <div class="recordDetail">
        <div class="title">
          <span>{{ singleRecord.roomName }}</span>
          <span>{{ singleRecord.date }}  {{ singleRecord.mealName }}</span>
        </div>
        <div class="content">
          <div class="item">床号：&nbsp;&nbsp;{{ singleRecord.bedName }}</div>
          <div class="item">姓名：&nbsp;&nbsp;{{ singleRecord.userName }}（{{ singleRecord.userNo }}）</div>
          <div class="meal">
            <span>餐品：&nbsp;&nbsp;</span>
            <span>{{ singleRecord.goodsName }}</span>
          </div>
          <div class="remark">
            <div v-if="singleRecord.orderFrom===2">
              <span>{{ singleRecord.catering }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span>{{ singleRecord.quality }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span v-if="singleRecord.attrList.length !==0">{{ singleRecord.attrList[0].attr }}</span>
            </div>
            <div v-if="singleRecord.orderFrom === 0">
              <span v-for="(item,index) in singleRecord.attrList">
                {{ item.groupName + "：" + item.attr }}&nbsp;&nbsp;
              </span>
            </div>
            <div v-if="singleRecord.orderFrom===2">
              <span v-if="singleRecord.cateringName">{{ singleRecord.cateringName }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span v-if="singleRecord.cateringName">{{ singleRecord.qualityName }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span v-if="singleRecord.attrName">{{ singleRecord.attrName }}</span>
            </div>
          </div>
          <div class="close" @click="recordDetail=false">
            <button>关闭</button>
          </div>
        </div>
      </div>
    </van-popup>
    <!--签收成功弹框-->
    <van-popup position="center" round v-model="signSuccess" :close-on-click-overlay="false">
      <div class="signSuccess">
        <div class="success">
          <img src="../../assets/images/completed.png" alt="">
        </div>
        <div class="close" @click="signSuccess = false">关闭</div>
      </div>
    </van-popup>
    <!-- 信息弹框 -->
    <van-popup position="center" round v-model="dischargeInformation" :closeable="true"  :close-on-click-overlay="false">
        <div class="discharge-information">
          <div class="discharge-list">
            <table>
              <tr v-for="(item,index) in leaveHospitalUsers" :key="index">
                <td>{{ item.bedName }}</td>
                <td>{{ item.userNo }}</td>
                <td>{{ item.name }}</td>
                <td>已出院</td>
              </tr>
            </table>
          </div>
          <div class="sub-btn" @click="dischargeInformation = false">确定</div>
        </div>
    </van-popup>

  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import {Toast} from "vant";

export default {
  name: "SignIn",
  components: {Navbar},
  data() {
    return {
      pageShow: false,
      recordDetail: false,
      uuid:'',
      date: null,
      mealId: null,
      roomId: null,
      type: null,  //0按餐品统计，1按地址统计
      localData: [],
      singleAddress: {},
      singleRecord: {},
      signSuccess: false,
      status: 0,
      dischargeInformation: false, //出院信息弹框
      leaveHospitalUsers:[] ,//出院名单列比较
    }
  },
  created() {
    let str = window.location.href;
    let arr1 = str.split('?');
    if (arr1[1].includes("uuid=") && !arr1[1].includes("&")) {
      this.uuid = arr1[1].split('=')[1];
    } else {
      let arr2 = arr1[1].split('&');
      arr2.map(item => {
        this.localData.push(item.split('=')[1])
      })
    }
  },
  beforeMount() {
    if(this.localData) {
      this.date = this.localData[0];
      this.mealId = this.localData[1];
      this.roomId = this.localData[2];
      this.type = this.localData[3];
    }
  },
  mounted() {
    this.getDeliveryInfo();
  },
  methods: {
    getDeliveryInfo(){
      if(this.uuid != ''){
        this.$post('delivery/roomSignInQrcodeInfo', {uuid:this.uuid}).then(res => {
          if(res.status != 200){
            Toast(res.msg);
            this.$router.push('/');
          }
          this.date = res.data.mealDay;
          this.mealId = res.data.mealId;
          this.roomId = res.data.roomId;
          this.type = 1;
          this.getDeliveryList();
        });
      }else{
        this.getDeliveryList();
      }
    },
    //展示单条记录
    showRecordDetail(orderItemId) {
      this.$post('delivery/detail', {orderItemId}).then(res => {
        if (res.status === 200) {
          this.singleRecord = res.data;
          this.recordDetail = true;
        }
      })
    },
    //获取配送列表
    getDeliveryList() {
      //date:日期，mealId:时段id，roomId:科室id，type:
      let data = {
        date: this.date,
        mealId: this.mealId,
        roomId: this.roomId,
        type: this.tabActive
      }
      this.$post('delivery/list', data).then(result => {
        this.singleAddress = result.data.orderInfo[0];
        this.status = result.data.status;
        this.pageShow = true;
        this.leaveHospitalUsers = result.data.leaveHospitalUsers;
        if(result.data.leaveHospitalUsers.length > 0 && result.data.status != 4){
          this.dischargeInformation = true;
        }
      });
    },
    confirmSign() {
      let data = {
        data: this.data,
        mealId: this.mealId,
        roomId: this.roomId,
        userType: this.uuid?2:1   //验收人类型，如果有uuid说明是配送员扫码签收（2），否则是护士扫码签收（1）
      }
      this.$post('delivery/signIn', data).then(result => {
        if (result.status === 200) {
          this.signSuccess = true;
          this.getDeliveryList()
        } else {
          Toast(result.msg);
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
.SignIn {
  font-size: 12px;
  .discharge-list{
      background: #FEF2F2;
      border-radius: 10px;
      overflow: hidden;
      margin-bottom: 30px;
      table{
        width: 100%;
        tr{
          font-weight: 400;
          height: 40px;
          line-height: 40px;
          color: #FF0000;
          font-size: 18px;
          td:nth-child(1) {
            padding-left: 10px;
          }

        }
      }
   }
  .division {
    height: calc(100vh - 44px);
    padding: 0 15px 0 10px;
    overflow-y: scroll;

    .noMore {
      margin-top: 20px;
      font-size: 12px;
      color: #CCCCCC;
      text-align: center;
    }

    .division-name {
      margin-top: 20px;
      font-size: 30px;
      font-weight: bold;
    }

    .date {
      color: #999999;
      font-size: 18px;
      margin-top: 16px;
    }
    .date-flex{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .date-flex-l{
          // flex: 1;
      }
      .date-flex-r{
          color: #333333;
          font-size: 15px;
          padding-left: 15px;
      }
    }
    .signatory{
      padding: 21px 0 30px;
      font-size: 15px;
      color: #333333;
    }
    .signatory {
      .signatory-title{
        margin-bottom: 14px;
      }
      .signatory-area{
        background: #F5F9FF;
        border-radius: 15px;
        height: 80px;
        border: 2px dashed #126AFC;
        color: #126AFC;
        font-weight: bold;
        font-size: 23px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    
    .grid-container {
      width: 100%;
      font-size: 12px;

      table:first-child {
        margin-top: 24px;
      }

      table {
        width: 100%;
        margin-top: 20px;
        tr {
          height: 40px;
          line-height: 40px;

          th:nth-child(1), td:nth-child(1) {
            padding-left: 10px;
          }
        }

        thead {
          tr {
            background: #DDDDDD;
          }
        }

        tbody {
          tr:nth-child(even) {
            background: #F5F5F5;
          }
          tr.tr-red{
            td{
              color: #FF0000 !important;
            }
          }
        }
      }

      .catering {
        table {
          tr {
            th, td {
              text-align: left;
            }

            th:nth-child(4), th:nth-child(5), th:nth-child(6), td:nth-child(4), td:nth-child(5), td:nth-child(6) {
              text-align: center;
            }
          }
        }
      }

      .meal {
        table {
          tr {
            th, td {
              text-align: left;
            }

            th:nth-child(4), td:nth-child(4) {
              display: block;
              width: 98px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }

      .catering-total {
        margin-top: 25px;

        .catering-title {
          text-align: center;
          font-size: 13px;
          font-weight: bold;
        }

        table {
          tr {
            th, td {
              text-align: left;
            }
          }
        }
      }

      .hospitalMeal {
        table {
          tr {
            th, td {
              text-align: left;
            }
          }
        }
      }

      .userMeal {
        table {
          tr {
            th, td {
              text-align: left;
            }
          }
        }
      }
    }

    .confirm {
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      margin-bottom: 35px;

      button {
        width: 100%;
        height: 50px;
        font-size: 15px;
        margin-top: 34px;
        border-radius: 25px;
        border: none;
      }
    }
  }

  .dining::-webkit-scrollbar {
    display: none;
  }

  .division::-webkit-scrollbar {
    display: none;
  }

  .recordDetail {
    width: 325px;
    padding: 25px 20px 20px 20px;
    box-sizing: border-box;
    font-size: 15px;

    .title {
      display: flex;
      flex-direction: column;
      align-items: center;

      span:nth-child(1) {
        font-size: 30px;
        font-weight: bold;
      }

      span:nth-child(2) {
        color: #999999;
        margin-top: 9px;
      }
    }

    .content {
      margin-top: 25px;

      .item {
        margin-top: 14px;
      }

      .item:first-child {
        margin-top: 0;
      }

      .meal {
        display: flex;
        align-items: flex-start;
        margin-top: 25px;

        span:nth-child(1) {
          white-space: nowrap;
        }

        span:nth-child(2) {
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
      }

      .remark {
        margin-top: 25px;
        padding-left: 54px;
        line-height: 25px;
      }

      .close {
        margin-top: 30px;

        button {
          width: 100%;
          height: 50px;
          border-radius: 25px;
          border: none;
          font-size: 18px;
        }
      }
    }
  }

  .signing, .signSuccess {
    .close {
      width: 100%;
      height: 50px;
      border-radius: 25px;
      background: #EEEEEE;
      font-size: 18px;
      color: #999999;
      text-align: center;
      line-height: 50px;
      margin-top: 20px;
    }
  }

  .signSuccess {
    width: 325px;
    padding: 0 20px 20px 20px;
    box-sizing: border-box;

    .success {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 80px;

      img {
        width: 285px;
      }
    }
  }
  .discharge-information{
    width: 85vw;
    padding: 60px 10px 20px;
    .sub-btn{
      width: 100%;
      height: 45px;
      text-align: center;
      line-height: 45px;
      border-radius: 10px;
      background: #126AFC;
      margin-top: 15px;
      color: #fff;
      font-size: 14px;
    }
  }
}
</style>